﻿import React from 'react';
import {
    Icon_Spin
} from '@Elements/ImageElements/Icons';
import { Submit_Button_Props } from '@Util/Types';

export default function Submit_Button(props: Submit_Button_Props): JSX.Element {
    function generate_element_class(): string {
        let class_str: string = "Form_Row Form_Row--Center";

        return class_str;
    }

    return (
        <div className={generate_element_class()}>
            <button
                type="submit"
                className="Button Button_Blue"
                disabled={props.disabled}
            >
                {
                    props.loading &&
                   <Icon_Spin />
                }
                {props.text}
            </button>
        </div>
    )
}